<div *ngIf="showLogin == true">
  <wm-login
    [redirectURL]="router.url"
    (loggedIn)="onLoggedIn()"
    [isPreview]="isPreview"
  ></wm-login>
    @if(!templateForPermitForm){
  <a
    class="nav-link"
    [routerLink]="['/auth/register']"
    [queryParams]="{ returnUrl: returnUrl }"
    [routerLinkActive]="['active']"
    >SIGNUP</a
  >
    }
    @else{
        <a
        class="nav-link"
        style="color: rgba(33, 150, 243, 1) !important;"
        [routerLink]="['/auth/register']"
        [queryParams]="{ returnUrl: returnUrl }"
        [routerLinkActive]="['active']"
        >SIGNUP</a
      >
    }
</div>
<div *ngIf="showLogin == false">
  <div *ngIf="canApplyOnBehalfOf">
    <div class="card" [ngClass]="{ 'card-content': templateForPermitForm }">
      <div class="card-body">
        <div>
          <div [formGroup]="userForm">
            <!--       Stack the columns on mobile by making one full-width and the other half-width -->
            <div class="row">
              <!-- added by priya 03-12-2025 -->

              @if(!templateForPermitForm){
              <div class="col-12 mb-2">
                Apply on behalf of:
              </div>
              }@else{
              <wm-common-text
                [data]="{ text: 'Apply on behalf of:' }"
                class="header"
              >
              </wm-common-text>
              }
              <!-- end by priya 03-12-2025 -->
            </div>
            <!-- added by priya 03-12-2025 -->

            <div
              [ngClass]="templateForPermitForm ? 'header-content' : 'row ml-2'"
            >
              <div
                [ngClass]="{
                  'col-3 col-sm-3 col-md-4 col-lg-2 col-xl-2': !templateForPermitForm
                }"
              >
                <!-- end by priya 03-12-2025 -->
                @if(!templateForPermitForm){
                <input
                  type="radio"
                  value="anotherUser"
                  formControlName="behalfOf"
                  [checked]="true"
                />
                Existing User }
                @else {
                <wm-common-radio formControlName="behalfOf" [data]="radioData">
                </wm-common-radio>
                }
              </div>
              <div
                [ngClass]="{
                  'col-9 col-sm-9 col-md-8 col-lg-10 col-xl-10': !templateForPermitForm,
                  disabledInActiveDiv:
                  templateForPermitForm && !behalfOfValue('anotherUser') && !behalfOfValue('loggedInUser')
                }"
              >
                <div class="card-title">
                  <span *ngIf="this.activity.model.user">{{
                    this.activity.model.user.userName
                  }}</span
                  ><span
                    *ngIf="this.activity.model.user"
                    [ngClass]="{ 'link-color': templateForPermitForm }"
                    >&nbsp;<a href="#" (click)="clearUser($event)">Clear</a></span
                  >
                </div>

                <wm-user-list-view
                  (selected)="selectUser($event)"
                  [raiseEvent]="true"
                  *ngIf="!this.activity.model.userId && !showRegister"
                ></wm-user-list-view>
              </div>
              <div *ngIf="templateForPermitForm && behalfOfValue('registerNewUser')">
                <wm-register
              *ngIf="showRegister"
              [showPasswordInput]="false"
              [returnURL]="returnUrl"
              [returnApplicationId]="returnApplicationId"
              (registered)="registered($event)"
              (canceled)="registerCanceled($event)"
              [raiseEvents]="true"
            >
            </wm-register>
            </div>
            <div *ngIf="templateForPermitForm"
            class="col-9 col-sm-9 col-md-8 col-lg-10 col-xl-10"
            [ngClass]="{
              disabledInActiveDiv: !behalfOfValue('loggedInUser')
            }"
          >
            {{ context.user?.userName }}
          </div>
            </div>

            <hr *ngIf="!templateForPermitForm" />
            <div  *ngIf="!templateForPermitForm"[ngClass]="{ 'row ml-2': !templateForPermitForm }">
              <div
                [ngClass]="{
                  'col-3 col-sm-3 col-md-4 col-lg-2 col-xl-2': !templateForPermitForm
                }"
              >
                <input
                  type="radio"
                  value="registerNewUser"
                  formControlName="behalfOf"
                  click="startRegister()"
                />
                New User
              </div>
              <div >
            
                <wm-register
                  *ngIf="showRegister"
                  [showPasswordInput]="false"
                  [returnURL]="returnUrl"
                  [returnApplicationId]="returnApplicationId"
                  (registered)="registered($event)"
                  (canceled)="registerCanceled($event)"
                  [raiseEvents]="true"
                >
                </wm-register>
              </div>
            
            </div>
            <hr />
            <!-- added by priya 03-12-2025 -->

            <div  *ngIf="!templateForPermitForm"
              [ngClass]="templateForPermitForm ? 'header-content' : 'row ml-2'"
            >
              <div
                [ngClass]="{
                  'col-3 col-sm-3 col-md-4 col-lg-2 col-xl-2': !templateForPermitForm
                }"
              >
                <!-- end by priya 03-12-2025 -->
                <input
                  type="radio"
                  value="loggedInUser"
                  formControlName="behalfOf"
                />
                Myself 
              </div>
              <div
                class="col-9 col-sm-9 col-md-8 col-lg-10 col-xl-10"
                [ngClass]="{
                  disabledInActiveDiv: !behalfOfValue('loggedInUser')
                }"
              >
                {{ context.user?.userName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
